import { Box } from "@mui/material";
import "./_style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkStepper from "../../components/atoms/TkStepper";
import { KikotableHeadList, stepper } from "./parts";
import TkBackButton from "../../components/molecules/TkBackButton";
import { useContext, useEffect, useState } from "react";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkButton from "../../components/atoms/TkButton";
import TkTable from "../../components/atoms/TkTable";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { httpAPI_STA011, httpAPI_STA026 } from "./api/request";
import { IAPI_STA011_Request, IAPI_STA026_Response } from "../../type/apiType";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { Status, TransferKbn } from "../../assets/data/Constants";

const SCRC060013 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //認証情報
  const { state, setState } = useContext(GlobalContext);
  //業務用Contextを更新するState
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [buttonTextFlug, setbuttonTextFlug] = useState(false);
  //機構へ提出のflug:true表示、false非表示
  const [isOpen, setIsOpen] = useState(false);
  const [bodyList, setBodyList] = useState<any>([]);
  const [httpReq, setHttpReq] = useState<IAPI_STA011_Request>({});
  const [btnStatus, setBtnStatus] = useState(false);
  const applyId =
    location.state?.applyId ??
    businessState.job_28?.applyId ??
    businessState.job_29?.applyId;
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;

  // 初期化
  const handleInit = async () => {
    try {
      // 申請id
      let applyIdNotApplicable; // 申請id（対象外施設異動）
      let applyIdReturn; // 申請id（復帰）
      const applyIdList: any = [];

      const businessType = businessState.common?.businessType;
      if (businessType === "JOB-28" || businessType === "JOB-29") {
        !!applyId && applyIdList.push({ applyId: applyId });
      } else {
        applyIdNotApplicable = businessState.job_27?.applyIdNotApplicable;
        applyIdReturn = businessState.job_27?.applyIdReturn;

        !!applyIdNotApplicable &&
          applyIdList.push({ applyId: applyIdNotApplicable });

        !!applyIdReturn && applyIdList.push({ applyId: applyIdReturn });
      }

      const res = await httpAPI_STA026({
        contractorNo,
        // 申請idがない場合は空リスト
        applyIdList: applyIdList,
      });
      if (res.resultCd === "I0000") {
        setBodyList(funFacilityInfoBodyList(res));

        const applyIdReqList = res.staffList?.map((staff: any) => ({
          applyId: staff.applyId, // 申請id
          businessType: staff.transferDateType === "1" ? "JOB-29" : "JOB-28",
          staffNo: staff.staffNo, // 職員番号
          receptionDate: staff.transferDate,
        }));

        let notApply = false;

        res?.staffList?.forEach((item: any) => {
          if (item?.processStatus === "登録済み") {
            return;
          } else {
            notApply = true;
            return;
          }
        });

        setBtnStatus(notApply);

        setHttpReq({
          ...httpReq,
          contractorNo,
          screenId: "SCRC060013",
          applyIdList: applyIdReqList,
        });
        setState({
          ...state,
          errorMsgId: "",
        });
        // 最新申請状態によってボタン表示を変える
        const shouldShowButtons =
          res.latestApplyStatus === Status["届出待ち"] ||
          res.latestApplyStatus === Status["差戻し一時保存"];
        setbuttonTextFlug(shouldShowButtons);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const funFacilityInfoBodyList = (res: IAPI_STA026_Response) => {
    let bodyList = res.staffList?.map((item) => [
      {
        children: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
      },
      {
        children:
          item.bFacilityName === null
            ? "999:契約対象外施設"
            : (item.bFacilityNo ?? "") + ":" + (item.bFacilityName ?? ""),
      },
      {
        children:
          item.aFacilityName === null
            ? "999:契約対象外施設"
            : (item.aFacilityNo ?? "") + ":" + (item.aFacilityName ?? ""),
      },
      {
        children: item.transferDateType
          ? item.transferDateType === "1"
            ? item.transferDate
            : item.returnDate
          : "",
        align: "center",
      },
      {
        children: item.processStatus,
      },
      {
        children: (
          <Box className="tableBtnGroup">
            <TkButton
              onClick={() => {
                handleRegist(
                  item.transferDateType,
                  item.applyId,
                  item.staffNo,
                  res.latestApplyStatus
                );
              }}
            >
              {res.latestApplyStatus === Status["届出待ち"] ||
              res.latestApplyStatus === Status["差戻し一時保存"]
                ? "登録"
                : "確認"}
            </TkButton>
          </Box>
        ),
        align: "center",
      },
    ]);

    return bodyList;
  };

  const handleRegist = (
    transferDateType: any,
    applyId: any,
    staffNo: any,
    latestApplyStatus: any
  ) => {
    let transferFlg = transferDateType === TransferKbn["転出"];
    let jobType = transferFlg ? ["JOB-29", "job_29"] : ["JOB-28", "job_28"];

    setBusinessState({
      ...businessState,
      common: {
        ...businessState.common,
        businessType: jobType[0],
      },
      [jobType[1]]: {
        applyId: applyId,
        staffNo: staffNo,
        latestApplyStatus: latestApplyStatus,
      },
    });

    if (transferFlg) {
      navigate("/SCRC060115");
    } else {
      navigate("/SCRC060114");
    }
  };

  const handleOk = async () => {
    // 配置換え職員一覧更新APIを呼び出す
    try {
      const res = await httpAPI_STA011(httpReq);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setIsOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC060013" data-testid="SCRC060013PageForTest">
      <TkStepper steps={stepper} activeStep={buttonTextFlug ? 0 : 1} />

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC060013_01}</TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          data-testid="contractorAndNumberLine"
          name={"契約者（法人）名"}
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <Box className="SCRC060013Table">
        <TkTable headList={KikotableHeadList} bodyList={bodyList} />
      </Box>
      <Box className="btns" textAlign="center">
        {!businessState?.job_27?.continuousRemoveFacilityFlag && (
          <TkBackButton />
        )}
        {buttonTextFlug && (
          <TkButton
            data-testid="organizationButton"
            onClick={() => setIsOpen(true)}
            disabled={btnStatus}
          >
            {isKiko ? "申請" : "機構へ提出する"}
          </TkButton>
        )}
      </Box>

      {isKiko ? (
        <TkDateDialog
          open={isOpen}
          onOky={handleOk}
          onCancel={() => setIsOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          data-testid="TkMessageDialog"
          open={isOpen}
          onOky={handleOk}
          onCancel={() => setIsOpen(false)}
          title="確認（機構へ提出する）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC060013;
